import React, { useEffect, useState } from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CredentialService from '../../../services/CredentialService/CredentialService';
import { TextInput } from '../TextInput/NewTextInput';
import InputBase from '@material-ui/core/InputBase';
import './CredentialPicker.css';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { changedFields, initialActions, saveAvailable } from "../../../recoil-store/recoil-state";
import { CheckIfFlowUpdated } from "../../../helpers/helper";
import { PasswordInput } from '../PasswordInput/NewPasswordInput';

const BootstrapInput = withStyles((theme) => ({
  input: {
    borderRadius: 2,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '0.5px solid #D5D5D5',
    paddingLeft: 5,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
  }
}))(InputBase);
function TabPanel({ children, value, index }) {
  return (<div>{value === index && (<Box>{children}</Box>)}</div>);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export function CredentialPicker({ action, inputName, variables, setOpenVariable, isRequired, isPassword, isVariableAdd = true, hideRequired }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CONNECT.';
  const [value, setValue] = useState(0);
  const [isCredentialPickerValue, setIsCredentialPickerValue] = useState(false);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const setChangeFields = useSetRecoilState(changedFields);
  const changedFieldsState = useRecoilValue(changedFields);

  useEffect(() => {
    if (!action.fields[inputName]) {
      action.fields[inputName] = { type: 'CREDENTIALPICKER', isRequired, value: '' };
    }
    if (action.fields[inputName].value) {
      if (typeof action.fields[inputName].value === 'object') { setValue(0); }
      else if (typeof action.fields[inputName].value === 'string') { setValue(1); }
    }
    else { setValue(0); }
  }, [action])

  const handleChange = (newValue) => {
    let newCredValue = action.fields[inputName].value;
    if (newValue === 1) {
      if (typeof action.fields[inputName] === "string") {
        newCredValue = action.fields[inputName].value ? action.fields[inputName].value : "";
      } else {
        newCredValue = ""
      }
    } else {
      newCredValue = ""
    }

    let field = initialActionsData[action.id]?.fields[inputName];

    if (!field) {
      field = { value: "" }
    }

    const oldValue = field.value
    CheckIfFlowUpdated(inputName, action, oldValue, newCredValue, setSaveAvailable, setChangeFields, changedFieldsState);

    action.fields[inputName] = { type: 'CREDENTIALPICKER', isRequired, value: { attributeId: '', credentialId: '' }, is_password: isPassword };
    setValue(newValue);
  };

  return (
    <div>
      <div className="condition-tabs">
        <button
          className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
          onClick={() => handleChange(0)}>
          {t(label + "CREDENTIAL")}
        </button>
        <button
          className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
          onClick={() => handleChange(1)}>
          {t(label + "CUSTOM-STRING")}
        </button>
      </div>

      <TabPanel value={value} index={0} >
        <SelectCredential action={action} inputName={inputName} isRequired={isRequired} setIsCredentialPickerValue={setIsCredentialPickerValue} />
      </TabPanel>
      <TabPanel value={value} index={1} >
        <InputCredential hideRequired={hideRequired} isPassword={isPassword} action={action} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} isRequired={isRequired} setIsCredentialPickerValue={setIsCredentialPickerValue} isCredentialPickerValue={isCredentialPickerValue} isVariableAdd={isVariableAdd} />
      </TabPanel>
    </div>
  );
}

function SelectCredential({ action, inputName, isRequired, setIsCredentialPickerValue }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CONNECT.';
  const [credentials, setCredentials] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [credentialValue, setCredentialValue] = useState('');
  const [attributeValue, setAttributeValue] = useState('');
  const [loadingCred, setLoadingCred] = useState(true);
  const [loadingAttr, setLoadingAttr] = useState(false);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const setChangeFields = useSetRecoilState(changedFields);
  const changedFieldsState = useRecoilValue(changedFields);

  useEffect(() => {
    fetchCredentials();
    if (!action.fields[inputName]) { action.fields[inputName] = { type: 'CREDENTIALPICKER', isRequired, value: '' }; }
    // if (action.fields[inputName].value && typeof action.fields[inputName].value === 'object') {
    //   setCredentialValue(action.fields[inputName].value.credentialId);
    //   fetchAttributes(action.fields[inputName].value.credentialId);
    //   setAttributeValue(action.fields[inputName].value.attributeId);
    // }
    else {
      setCredentialValue('');
      setAttributeValue('');
    }
  }, [action])

  const fetchCredentials = async () => {
    const response = await CredentialService.getCredentials("1");
    if (response) {
      setCredentials(response.data);
      if (action.fields[inputName].value && typeof action.fields[inputName].value === 'object') {
        const isFind = response.data.find((item) => item.connection_id === action.fields[inputName].value.credentialId)
        if (isFind) {
          setCredentialValue(action.fields[inputName].value.credentialId);
          fetchAttributes(action.fields[inputName].value.credentialId);
        }
        else {
          action.fields[inputName] = { type: 'CREDENTIALPICKER', isRequired, value: '' }
        }
      }
    }
    setLoadingCred(false);
  }
  const fetchAttributes = async (id) => {
    if (id) {
      setLoadingAttr(true);
      const response = await CredentialService.getCredentialByFilter(id);
      if (response) {
        setAttributes(response.data.connection_attributes);
        if (response.data?.id) {
          setAttributeValue(action.fields[inputName].value.attributeId);
        }
      }
      setLoadingAttr(false);
    }
  }

  const handleChangeCredential = (event) => {
    if (typeof action.fields[inputName].value === "string") {
      action.fields[inputName].value = {
        credentialId: event.target.value,
        attributeId: ""
      }
    } else {
      action.fields[inputName].value.credentialId = event.target.value;
    }

    const newValue = action.fields[inputName].value;
    let field = initialActionsData[action.id]?.fields[inputName];

    if (!field) {
      field = {
        value: { attributeId: '', credentialId: '' }
      }
    }
    const oldValue = field.value
    CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
    if (!action.fields[inputName].value || typeof action.fields[inputName].value === 'string') {
      action.fields[inputName].value = { credentialId: '', attributeId: '' };
    }
    setCredentialValue(event.target.value);
    fetchAttributes(event.target.value);
    action.fields[inputName].value.credentialId = event.target.value;
  }
  const handleChangeAttribute = (event) => {
    if (typeof action.fields[inputName].value === "string") {
      action.fields[inputName].value = {
        credentialId: "",
        attributeId: event.target.value
      }
    } else {
      action.fields[inputName].value.attributeId = event.target.value;
    }

    const newValue = action.fields[inputName].value;
    let field = initialActionsData[action.id]?.fields[inputName];

    if (!field) {
      field = {
        value: { attributeId: '', credentialId: '' }
      }
    }

    const oldValue = field.value
    CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
    setAttributeValue(event.target.value);
    action.fields[inputName].value.attributeId = event.target.value;
    setIsCredentialPickerValue(true);
  }
  return (
    <div>
      <FormControl variant="outlined" className="cred-selects">
        <InputLabel style={{ fontSize: "12px" }}>{t(label + 'CREDENTIAL')}</InputLabel>
        {!loadingCred && <Select value={credentialValue} onChange={handleChangeCredential} label={t(label + 'CREDENTIAL')} input={((action.fields[inputName]?.value || credentialValue) || !isRequired) ? null : <BootstrapInput />} >
          {credentials?.length > 0 ? credentials?.map((item, itemI) =>
            <MenuItem key={itemI} value={item.connection_id}>{item.connection_name}</MenuItem>
          ) :
            <MenuItem value=""><em>{t(label + 'NO-CRED')}</em></MenuItem>
          }
        </Select>}
      </FormControl>
      <FormControl variant="outlined" className="cred-selects">
        <InputLabel style={{ fontSize: "12px" }}>{t(label + 'ATTRIBUTE')}</InputLabel>
        {!loadingAttr && <Select value={attributeValue} onChange={handleChangeAttribute} label={t(label + 'ATTRIBUTE')} input={((action.fields[inputName]?.value || credentialValue) || !(attributeValue || isRequired)) ? null : <BootstrapInput />} >
          {attributes?.length > 0 ? attributes?.map((item, itemI) =>
            <MenuItem key={itemI} value={item.id}>{item?.name}</MenuItem>
          ) :
            <MenuItem value=""><em>{t(label + 'NO-ATTR')}</em></MenuItem>
          }
        </Select>}
      </FormControl>
    </div>
  );
}

function InputCredential({ action, inputName, variables, setOpenVariable, isRequired, setIsCredentialPickerValue, isCredentialPickerValue, isPassword, isVariableAdd, hideRequired }) {
  const [, setInputValue] = useState('');
  useEffect(() => {
    if (!action.fields[inputName]?.value || typeof action.fields[inputName]?.value === 'object') {
      setInputValue('');
    }
    else { setInputValue(action.fields[inputName]?.value); }
  }, [action])
  return (
    <>
      {isPassword
        ? <PasswordInput isPassword={isPassword} inputName={inputName} action={action} variables={variables} setOpenVariable={setOpenVariable} isRequired={isRequired} isCredentialPickerValue={isCredentialPickerValue} isVariableAdd={isVariableAdd} hideRequired={hideRequired} />
        : <TextInput isPassword={isPassword} inputName={inputName} action={action} variables={variables} setOpenVariable={setOpenVariable} isRequired={isRequired} isCredentialPickerValue={isCredentialPickerValue} isVariableAdd={isVariableAdd} hideRequired={hideRequired} />
      }
    </>
  );
}
